module.exports = __webpack_public_path__ + "img/37074559_242781556533238_2882946447538388992_n.jpg";